import { render, staticRenderFns } from "./ShopCard.vue?vue&type=template&id=3431f580&scoped=true&"
import script from "./ShopCard.vue?vue&type=script&lang=js&"
export * from "./ShopCard.vue?vue&type=script&lang=js&"
import style0 from "./ShopCard.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ShopCard.vue?vue&type=style&index=1&id=3431f580&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3431f580",
  null
  
)

export default component.exports